import React from 'react';
import '../styles/buildmanager.css';

interface Gem {
  name: string;
  type: string;
  tags: string;
  description: string;
  effects: string[];
}

interface Build {
  id: string;
  name: string;
  skillSockets: (Gem | null)[];
  supportSockets: (Gem | null)[][];
  isExpanded: boolean[];
}

interface BuildManagerProps {
  builds: Build[];
  currentBuild: Build | undefined;
  onCreateBuild: () => void;
  onSelectBuild: (id: string) => void;
  onRenameBuild: (id: string, name: string) => void;
  onDeleteBuild: (id: string) => void;
  onShareBuild: (build: Build) => void;
}

export const BuildManager: React.FC<BuildManagerProps> = ({
  builds,
  currentBuild,
  onCreateBuild,
  onSelectBuild,
  onRenameBuild,
  onDeleteBuild,
  onShareBuild
}) => {
  return (
    <div className="build-manager">
      <div className="build-list">
        {builds.map(build => (
          <div 
            key={build.id}
            className={`build-item ${build.id === currentBuild?.id ? 'active' : ''}`}
          >
            <input
              type="text"
              value={build.name}
              onChange={(e) => onRenameBuild(build.id, e.target.value)}
              onClick={(e) => e.stopPropagation()}
            />
            <div className="build-actions">
              <button onClick={() => onSelectBuild(build.id)}>Load</button>
              <button onClick={() => onShareBuild(build)}>Share</button>
              <button onClick={() => onDeleteBuild(build.id)}>Delete</button>
            </div>
          </div>
        ))}
      </div>
      <button className="create-build" onClick={onCreateBuild}>
        Create New Build
      </button>
    </div>
  );
}; 